// import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form } from 'react-bootstrap';
import '../../App.css';
import Button from '@mui/material/Button';

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            login: '', password: '', isLoggedIn: false, inputError: false, inputValid: false
        };
        this.handleChangeLogin = this.handleChangeLogin.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleClickLogin = this.handleClickLogin.bind(this);
        this.handleClickPassword = this.handleClickPassword.bind(this);
        // delete Token + user_id + rolle from LocalStorage
        localStorage.clear()
    }

    handleClickLogin(event){
        this.setState({login: ''})
    }

    handleClickPassword(event){
        this.setState({password: ''})
    }
    // fetch by adding charachters in country-inputform
    handleChangeLogin(event) {
        // if (event.target.value.length > 0) {
            this.setState({ login: event.target.value });
        // }
    };

    // fetch by adding charachters in country-inputform
    handleChangePassword(event) {
        // if (event.target.value.length > 0) {
            this.setState({ password: event.target.value });
        // }
    };
    async submitLogin(event) {
        event.preventDefault();
        if(this.state.login && this.state.password) {

        await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/login?login=${encodeURIComponent(this.state.login)}&password=${encodeURIComponent(this.state.password)}`)
            .then((response) => response.json())
            .then(jwToken => {
                localStorage.setItem('jwToken', jwToken.token)
                localStorage.setItem('user_id', jwToken.id)
                localStorage.setItem('role_id', jwToken.role_id)
                localStorage.setItem('firstname', jwToken.firstname)
                localStorage.setItem('lastname', jwToken.lastname)
                localStorage.setItem('firm', jwToken.firm)
                localStorage.setItem('email', jwToken.email)

                if(jwToken.country === 'Brazil' || jwToken.country === 'Brasilien') {
                    localStorage.setItem('language', 'pt-br')
                } else if(jwToken.country === 'Germany' || jwToken.country === 'Deutschland') {
                    localStorage.setItem('language', 'de')
                } else {
                    localStorage.setItem('language', 'en')
                }
                // console.log(localStorage.getItem('jwToken'))
                this.setState({ inputError: false, inputValid: true}, () => {
                    this.setState({isLoggedIn: true}) 
                })
            })
            .catch( error => this.setState({ inputError: true}) );
        }else {
            this.setState({ inputError: true})
        }
    }

    render() {
   
        if(this.state.isLoggedIn) {
            window.location.href = '/home';
        }
        return (
            <div>
                 
                <Form className="login-form">
                    <Form.Group controlId="formEmail" style={{ width: "300px" }}>
                        <Form.Label>Login</Form.Label>
                        <Form.Control 
                        value={this.state.login} 
                        onChange={this.handleChangeLogin} 
                        onClick={this.handleClickLogin} 
                        placeholder="Please enter your name"
                        isInvalid={this.state.inputError}
                        isValid={this.state.inputValid} />

                    </Form.Group>

                    <Form.Group controlId="formPassword" style={{ width: "300px", margin: "5px" }}>
                        <Form.Label>Password</Form.Label>
                        <Form.Control 
                        value={this.state.password} 
                        onChange={this.handleChangePassword} 
                        onClick={this.handleClickPassword} 
                        type="password" 
                        placeholder="Please enter your password"
                        isInvalid={this.state.inputError}
                        isValid={this.state.inputValid} />
                    </Form.Group>
                    <Button style={{margin: '5px'}} variant="contained" color="primary"  type="submit" onClick={this.submitLogin.bind(this)} >
                    Login
                    </Button>
                </Form>
            </div>
        )
    }

}

export default Login;